module.exports = __webpack_public_path__ + "static/img/logo_6.dbdb3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_6.png
// module id = 6f55
// module chunks = 1